/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DisplaySlotType = {
    Image: 'Image',
    StaticText: 'StaticText',
    DynamicText: 'DynamicText',
    ImageWithOverlayText: 'ImageWithOverlayText'
} as const;
export type DisplaySlotType = typeof DisplaySlotType[keyof typeof DisplaySlotType];

